import { createSlice, PayloadAction, Draft } from "@reduxjs/toolkit";
import { NotistackState, OpenSnackbarPayload } from "@/redux/notistack/types";
import { SnackbarKey } from "notistack";
import { getStateKeyList } from "@/utils/redux/state";

const initialState: NotistackState = {
	snackbarList: [],
};

export const NOTISTACK_STATE_KEY_LIST = getStateKeyList(initialState);

export const notistackSlice = createSlice({
	name: "notistack",
	initialState,
	reducers: {
		reset: () => initialState,
		openSnackbar: (state, { payload }: PayloadAction<OpenSnackbarPayload>) => {
			state.snackbarList = [
				...state.snackbarList,
				{
					...(payload as Draft<OpenSnackbarPayload>),
					key: payload.key ?? `${Date.now()}.${Math.random()}`,
				},
			];
		},
		removeSnackbar: (state, { payload }: PayloadAction<SnackbarKey | undefined>) => {
			if (typeof payload === "undefined") {
				state.snackbarList = [];
				return;
			}
			state.snackbarList = state.snackbarList.filter(({ key }) => key !== payload);
		},
	},
});

export const notistackReducer = notistackSlice.reducer;
